import text from './resources/locale/en.json';

class RequiredFieldController {
    $onInit() {
        this.text = text;
    }
}

export default RequiredFieldController;
